import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { ClipboardListIcon, PlusIcon, BarChart3Icon, ClockIcon, CheckCircle2Icon } from 'lucide-react';
export function SurveysPage() {
  const surveys = [{
    title: 'Pre-Event Intake',
    type: 'Intake',
    status: 'Active',
    responses: '41/48',
    date: 'Closes May 10',
    color: 'teal'
  }, {
    title: 'Day 1 Pulse Check',
    type: 'Pulse',
    status: 'Scheduled',
    responses: '-',
    date: 'Sends May 12, 17:00',
    color: 'amber'
  }, {
    title: 'Day 2 Pulse Check',
    type: 'Pulse',
    status: 'Scheduled',
    responses: '-',
    date: 'Sends May 13, 17:00',
    color: 'amber'
  }, {
    title: 'Post-Event Reflection',
    type: 'Comprehensive',
    status: 'Draft',
    responses: '-',
    date: 'Sends May 15',
    color: 'slate'
  }];
  return <DashboardLayout pageTitle="Surveys & Feedback" breadcrumb="Leadership Reset Retreat" data-id="element-1844">
      <div className="flex justify-between items-center mb-8" data-id="element-1845">
        <p className="text-slate-600" data-id="element-1846">
          Manage attendee intake, daily pulses, and post-event feedback.
        </p>
        <Button variant="primary" data-id="element-1847">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-1848" /> Create Survey
        </Button>
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-1849">
        <div className="lg:col-span-2 space-y-4" data-id="element-1850">
          {surveys.map((survey, i) => <div key={i} className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 group hover:border-brand-teal/50 transition-colors" data-id="element-1851">
              <div className="flex items-start gap-4" data-id="element-1852">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${survey.status === 'Active' ? 'bg-brand-teal/10 text-brand-teal' : survey.status === 'Scheduled' ? 'bg-amber-50 text-amber-600' : 'bg-slate-100 text-slate-400'}`} data-id="element-1853">
                  <ClipboardListIcon className="w-5 h-5" data-id="element-1854" />
                </div>
                <div data-id="element-1855">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1856">
                    <h3 className="font-bold text-brand-navy text-lg" data-id="element-1857">
                      {survey.title}
                    </h3>
                    <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-100 text-slate-500" data-id="element-1858">
                      {survey.type}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-1859">
                    <span className="flex items-center gap-1.5" data-id="element-1860">
                      <ClockIcon className="w-4 h-4" data-id="element-1861" /> {survey.date}
                    </span>
                    {survey.status === 'Active' && <span className="flex items-center gap-1.5 text-emerald-600 font-medium" data-id="element-1862">
                        <CheckCircle2Icon className="w-4 h-4" data-id="element-1863" />{' '}
                        {survey.responses} Responses
                      </span>}
                  </div>
                </div>
              </div>
              <div className="flex gap-2 sm:flex-col lg:flex-row" data-id="element-1864">
                {survey.status === 'Active' ? <Button variant="outline" size="sm" data-id="element-1865">
                    <BarChart3Icon className="w-4 h-4 mr-2" data-id="element-1866" /> Results
                  </Button> : <Button variant="outline" size="sm" data-id="element-1867">
                    Edit
                  </Button>}
              </div>
            </div>)}
        </div>

        <div className="space-y-6" data-id="element-1868">
          <div className="bg-brand-navy rounded-2xl p-6 text-white shadow-soft" data-id="element-1869">
            <h3 className="font-bold text-lg mb-2" data-id="element-1870">Survey Best Practices</h3>
            <p className="text-sm text-slate-300 mb-4" data-id="element-1871">
              AI analysis shows higher completion rates when surveys are kept
              under 3 minutes.
            </p>
            <ul className="space-y-3 text-sm text-slate-200" data-id="element-1872">
              <li className="flex items-start gap-2" data-id="element-1873">
                <CheckCircle2Icon className="w-4 h-4 text-brand-teal shrink-0 mt-0.5" data-id="element-1874" />{' '}
                Keep daily pulses to 1-2 questions
              </li>
              <li className="flex items-start gap-2" data-id="element-1875">
                <CheckCircle2Icon className="w-4 h-4 text-brand-teal shrink-0 mt-0.5" data-id="element-1876" />{' '}
                Send post-event survey within 24h
              </li>
              <li className="flex items-start gap-2" data-id="element-1877">
                <CheckCircle2Icon className="w-4 h-4 text-brand-teal shrink-0 mt-0.5" data-id="element-1878" />{' '}
                Use mix of scale and open-text
              </li>
            </ul>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}